export default "__VITE_ASSET__oPfq9xR0__"